import axios from 'axios';
import { put, call, takeLeading, delay } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { api_urls } from '../../utils/api-urls';
import Swal from "sweetalert2";
import { change_yatra_status, create_yatra, delete_yatra, get_yatra, update_yatra } from '../../utils/api-routes';

function* getYatra() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_yatra}`);
        console.log("Get Yatra Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_YATRA, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Yatra Saga Error ::: ", error)
    }
}

function* createYatra(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_yatra}`, payload?.data);
        console.log("Create Yatra Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "Yatra Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: 'Failed To Create Yatra',
            text: "Failed To Create ",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create Yatra Saga Error ::: ", error?.response?.data)
    }
}

function* updateYatra(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_yatra}`, payload?.data);
        console.log("Update Yatra Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "Yatra Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_YATRA, payload: null })
        }

    } catch (error) {
        console.log("Update Yatra Saga Error ::: ", error?.response?.data)
    }
}

function* deleteYatra(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_yatra}`, payload);
            console.log("Delete Yatra Saga Response ::: ", data)
            if (data.status) {
                Swal.fire({
                    icon: "success",
                    title: "Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_YATRA, payload: null })

            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Delete ",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete Yatra Saga Error ::: ", error?.response?.data)
    }
}

function* changeYatraStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_yatra_status}`, payload);
            console.log("Change Status Yatra Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_YATRA, payload: null })
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change Status Yatra Saga Error ::: ", error?.response?.data)
    }
}

export default function* yatraSaga() {
    yield takeLeading(actionTypes?.GET_YATRA, getYatra);
    yield takeLeading(actionTypes?.CREATE_YATRA, createYatra);
    yield takeLeading(actionTypes?.UPDATE_YATRA, updateYatra);
    yield takeLeading(actionTypes?.DELETE_YATRA, deleteYatra);
    yield takeLeading(actionTypes?.CHANGE_YATRA_STATUS, changeYatraStatus);
}
